import React, { Component } from 'react';
import {
  Router,
  Route,
  Redirect,
} from 'react-router-dom'

import { createBrowserHistory } from "history";
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Login } from './components/Login';
import { Clienti1 } from './components/Clienti1';
import { Clienti2 } from './components/Clienti2';
import { NuovoClienteMenu } from './components/NuovoClienteMenu';
import { NuovoOrdineMenu } from './containers/NuovoOrdineMenuContainer';
import { AddArticoli } from './components/AddArticoli';
import ListinoContainer from './containers/ListinoContainer';
import NuovoOrdineContainer from './containers/NuovoOrdineContainer';
import StoricoOrdineContainer from './containers/StoricoOrdineContainer';
import NuovoVersamentiContainer from './containers/NuovoVersamentiContainer';
import StoricoVersamentoContainer from './containers/StoricoVersamentoContainer';
import UtentiContainer from './containers/UtentiContainer';
import { Catalogo } from './components/Catalogo/Catalogo';
import CatalogoContainer from './containers/CatalogoContainer';
//import SalvadanaioContainer from './containers/SalvadanaioContainer';
import ContoDeposito from './components/NuovoOrdine/ContoDeposito';
import StatisticheContainer from './containers/StatisticheContainer';

import FattureScaduteContainer from './containers/FattureScaduteContainer';

const history = createBrowserHistory();

history.listen((location, action) => {

  if(!location.pathname.includes("order") && !location.pathname.includes("articolo")){
    clearArticoli();
  }
});

const clearArticoli = () => {
  sessionStorage.setItem("codiceCliente", '');
  sessionStorage.setItem("clienteRagSoc", '');
  sessionStorage.setItem("articoli", '[]');
  sessionStorage.setItem("posizione", '');
}

const PrivateRoute = ({ component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    localStorage.getItem(sessionStorage.getItem("auth")) !==null || (sessionStorage.getItem("auth") !== null && new Date(sessionStorage.getItem("authExp")) >= new Date())
      ? <Component {...props} />
      : <Redirect push to="/login" />
  )} />
)

const getRole = () => {

  const role = sessionStorage.getItem("selectedRole");
 
  if(role){
    return role;
  }
  else{
    return "Role";
  }
}

export default class App extends Component {
  static displayName = App.name;

  state = {
    role: getRole(),
  }

  assignRole = (newRole) => {    
      this.setState({
        role: newRole
      });

      sessionStorage.setItem("selectedRole", newRole);
  }

  render () {
    return (
      <Router history={history} role={this.state.role} setRole={this.assignRole.bind(this)}>
        <Layout history ={history} role={this.state.role} setRole={this.assignRole.bind(this)}>
          <Route exact path='/' component={Home} />
          <Route path='/fetch-data' component={FetchData} />
          <Route path='/login' component={() => <Login history={history} setRole={this.assignRole.bind(this)}/>} />
          <PrivateRoute path='/listinoPrezzi' component={() => <ListinoContainer history={history} />} />
          <PrivateRoute path='/fattureScadute' component={() => <FattureScaduteContainer history={history} />} />
          <PrivateRoute path='/Catalogo' component={() => <CatalogoContainer history={history} />} />
          <PrivateRoute path='/ricercaCliente' component={() => <Clienti1 history={history} role={this.state.role}/>}/>
          <PrivateRoute path='/clienti/view/:id' component={(props) => <Clienti2 history={history} role={this.state.role} match={props.match} isNew={false}/>}/>
          <PrivateRoute path='/nuovoCliente' component={(props) => <NuovoClienteMenu history={history} role={this.state.role} isNew={true}/> } />
          <PrivateRoute path='/cliente/add' component={(props) => <Clienti2 history={history} role={this.state.role} match={props.match} isNew={true}/> } />
          <PrivateRoute path='/cliente/approve/:id' component={(props) => <Clienti2 history={history} role={this.state.role} match={props.match} isNew={true} isApprove={true}/> } />
          <PrivateRoute path='/nuovoOrdine' component={(props) => <NuovoOrdineMenu history={history} role={this.state.role} match={props.match} /> } />
          <PrivateRoute path='/order/add' component={() => <NuovoOrdineContainer history={history} /> } />
          <PrivateRoute path='/contoDeposito' component={() => <ContoDeposito history={history} /> } />          
          <PrivateRoute path='/order/articolo/:id' component={(props) => <AddArticoli history={history} nuovoOrdine={true} match={props.match}/> } />
          <PrivateRoute path='/storicoOrdine' component={(props) => <StoricoOrdineContainer history={history} /> } />
          <PrivateRoute path='/nuovoVersamento' component={(props) => <NuovoVersamentiContainer history={history} /> } />
          <PrivateRoute path='/storicoVersamenti' component={(props) => <StoricoVersamentoContainer history={history} /> } />
          {/*<PrivateRoute path='/Salvadanaio' component={(props) => <SalvadanaioContainer history={history} />} />*/}
          <PrivateRoute path='/Statistiche' component={(props) => <StatisticheContainer history={history} />} />
          <PrivateRoute path='/test' component={(props) => <UtentiContainer history={history} />} />
       </Layout>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js